import consolaBrowser from 'consola/src/browser'

const options = {}

// Відображаюмо debug тільки в режимі розробки
if (process.env.DEV) {
  options.level = 4
}

export default consolaBrowser.create(options)
